// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1SvYQ","right":"Footer_right__1F-wM","buttons":"Footer_buttons__sk-wA"};